import { render, staticRenderFns } from "./BesarKematianRanap.vue?vue&type=template&id=08cfc4ed"
import script from "./BesarKematianRanap.vue?vue&type=script&lang=js"
export * from "./BesarKematianRanap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\Work\\laporan-rl\\sembiring_rekammedis\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08cfc4ed')) {
      api.createRecord('08cfc4ed', component.options)
    } else {
      api.reload('08cfc4ed', component.options)
    }
    module.hot.accept("./BesarKematianRanap.vue?vue&type=template&id=08cfc4ed", function () {
      api.rerender('08cfc4ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/app/rlexternal/mordibilitas-ranap/BesarKematianRanap.vue"
export default component.exports